import { gql } from "@apollo/client";

import { SUBSCRIPTION_FRAGMENT } from "@graphql/fragments";

export const GET_SUBSCRIPTION = gql`
  ${SUBSCRIPTION_FRAGMENT}

  query getSubscription {
    getSubscription {
      ...SubscriptionFragment
    }
  }
`;
